import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import Image from "next/image";
import React, { useState } from "react";

import { GetLibraryResponseDto } from "@onair/repositories";

interface LibraryItemProps {
	library: GetLibraryResponseDto;
	handleEditSubLibrary: (id: string, name: string) => void;
	onSelectLibrary: (id: string, name: string) => void;
	onDelete: (id: string) => Promise<any>;
	refetch: () => Promise<any>;
}

const SubLibraryItem = ({
	library,
	handleEditSubLibrary,
	onSelectLibrary,
	onDelete,
}: LibraryItemProps) => {
	const { id, name } = library;
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
	const open = Boolean(anchorEl);

	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleCloseMenu = () => {
		setAnchorEl(null);
	};

	const handleDeleteLibrary = () => {
		onDelete(id);
		handleCloseMenu();
	};

	const onHandleEditSubLibrary = () => {
		handleEditSubLibrary(id, name);
		handleCloseMenu();
	};

	return (
		<Grid item xs={24} sm={6} key={id}>
			<Card
				variant="outlined"
				className="flex items-center justify-between p-2 rounded-md bg-[#F4F6F8] shadow-transparent cursor-pointer"
			>
				<Box
					className="flex flex-1 items-center gap-2"
					onClick={() => onSelectLibrary(id, name)}
				>
					<Box className="flex overflow-hidden rounded-md w-12 h-12 items-center justify-center">
						<Image
							loading="lazy"
							src="/assets/icons/online-course/ic-library.svg"
							alt={name}
							width={48}
							height={48}
							className="object-cover h-full"
						/>
					</Box>

					<Typography
						onClick={() => onSelectLibrary(id, name)}
						className="text-sm font-normal overflow-hidden text-ellipsis max-w-[200px] web break-words line-clamp-1"
					>
						{name}
					</Typography>
				</Box>

				<IconButton aria-label="more" onClick={handleClick}>
					<MoreVertIcon />
				</IconButton>

				<Menu
					id="basic-menu"
					anchorEl={anchorEl}
					open={open}
					onClose={handleCloseMenu}
					MenuListProps={{
						"aria-labelledby": "basic-button",
					}}
				>
					<MenuItem disableRipple onClick={onHandleEditSubLibrary}>
						<EditIcon className="mr-3" /> Đổi tên
					</MenuItem>
					<MenuItem disableRipple onClick={handleDeleteLibrary}>
						<DeleteIcon className="mr-3" /> Xoá
					</MenuItem>
				</Menu>
			</Card>
		</Grid>
	);
};

export default SubLibraryItem;
